import axios from "../../../axios";

export const getOrg =async () => {
        try {  
            let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization`);            
            return data
        }
        catch (err) {
            console.log("Error while getting groups of an organization", err.message);
        }
}